import React, { useEffect, useState } from 'react'
import Lottie from 'react-lottie'
import { Button, CheckmarkCircleIcon, colors } from '@diversioteam/diversio-ds'

import { FileWithPath } from 'components/ Lumi/context/LumiContext.types'
import * as loadingCircle from 'assets/lottie/lumi/loadingCircle.json'

import * as S from './acceptedFile.styles'

export const AcceptedFile = ({
    acceptedFile,
    onChangeProcessing,
    ...props
}: {
    acceptedFile: FileWithPath
    onChangeProcessing: (value: boolean) => void
}) => {
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        onChangeProcessing(true)

        const timeout = setTimeout(() => {
            setIsLoading(false)

            onChangeProcessing(false)
        }, 3000)

        return () => clearTimeout(timeout)
    }, [])

    const bytesToSize = (bytes: number) => {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']

        if (bytes === 0) return 'n/a'

        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10)

        if (i === 0) return `${bytes} ${sizes[i]})`

        return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`
    }

    return (
        <S.AcceptedFile {...props}>
            <S.IconWrapper>
                {isLoading && (
                    <Lottie
                        options={{
                            loop: 1,
                            autoplay: true,
                            animationData: loadingCircle,
                            rendererSettings: {
                                preserveAspectRatio: 'xMidYMid slice',
                            },
                        }}
                    />
                )}

                {!isLoading && <CheckmarkCircleIcon color={colors.primary40} />}
            </S.IconWrapper>

            <S.Details>
                <S.Path>{acceptedFile.path}</S.Path>
                <S.Size>{bytesToSize(acceptedFile.size)}</S.Size>
            </S.Details>

            <S.Buttons>
                <Button color="secondaryError" onClick={() => {}}>
                    Remove
                </Button>
            </S.Buttons>
        </S.AcceptedFile>
    )
}
